import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";
import TranslationContext from "../providers/TranslationContext";
import withComponentOverride from "../withComponentOverride";
const MessageContainer = withComponentOverride(styled.div `
	display: flex;
	flex-direction: column;
	align-items: start;
	align-self: ${({ variant }) => (variant === "user" ? "end" : "start")};
	max-width: ${({ variant }) => {
    switch (variant) {
        case "user":
        case "support":
            return "70%";
        default:
            return "none";
    }
}};
`);
const MessageNick = withComponentOverride(styled.div `
	color: ${({ theme }) => theme.colors.messageNickColor};
	font-weight: 400;
	font-size: ${({ fontSize }) => fontSize - 4}px;
	margin-bottom: 8px;
`);
const Message = withComponentOverride(styled.div `
	white-space: pre-wrap;
	word-wrap: break-word;
	background: ${({ variant, theme }) => {
    switch (variant) {
        case "user":
            return theme.colors.messageUserBg;
        case "support":
            return theme.colors.messageSupportBg;
        default:
            return "transparent";
    }
}};
	border-radius: ${({ variant }) => {
    switch (variant) {
        case "user":
            return "24px 24px 0 24px";
        case "support":
            return "24px 24px 24px 0";
        default:
            return "initial";
    }
}};
	color: ${({ variant, theme }) => {
    switch (variant) {
        case "user":
            return theme.colors.messageUserColor;
        case "support":
            return theme.colors.messageSupportColor;
        case "welcome":
            return theme.colors.messageWelcomeColor;
        case "system":
        default:
            return theme.colors.messageSystemColor;
    }
}};
	padding: ${({ variant }) => {
    switch (variant) {
        case "user":
            return "12px 18px 12px 16px";
        case "support":
            return "12px 16px";
        default:
            return "0";
    }
}};
	font-size: ${({ fontSize }) => fontSize}px;
	font-weight: 400;

	a {
		color: ${({ variant, theme }) => {
    switch (variant) {
        case "user":
            return theme.colors.messageUserLinkColor;
        default:
            return theme.colors.messageSupportLinkColor;
    }
}};

		&:hover {
			color: ${({ variant, theme }) => {
    switch (variant) {
        case "user":
            return theme.colors.messageUserLinkHoverColor;
        default:
            return theme.colors.messageSupportLinkHoverColor;
    }
}};
		}
	}
`);
const MessageAdditional = withComponentOverride(styled.div `
	white-space: pre-wrap;
	word-wrap: break-word;
	color: ${({ theme }) => theme.colors.messageAdditionalColor};
	background: ${({ theme }) => {
    return theme.colors.messageAdditionalBg;
}};
	border-radius: 0 24px 24px 24px;
	padding: 12px 16px;
	font-weight: 400;
	font-size: ${({ fontSize }) => fontSize}px;

	a {
		color: ${({ theme }) => theme.colors.messageAdditionalLinkColor};

		&:hover {
			color: ${({ theme }) => theme.colors.messageAdditionalLinkHoverColor};
		}
	}
`);
const MessageItem = ({ type, nick, fontSize, additionalMessage, children }) => {
    const { components } = useTheme();
    const { supportNickSuffix } = useContext(TranslationContext);
    const displayNick = nick && supportNickSuffix ? [nick, supportNickSuffix].join(" | ") : nick;
    return (_jsxs(MessageContainer, { variant: type, componentOverride: components?.MessageContainer, children: [displayNick && type === "support" && (_jsx(MessageNick, { variant: type, fontSize: fontSize, "data-testid": `support-chat-message-nick-${type}`, componentOverride: components?.MessageNick, children: displayNick })), additionalMessage && (_jsxs(_Fragment, { children: [_jsx(Message, { variant: type, fontSize: fontSize, "data-hj-suppress": "", "data-testid": `support-chat-message-${type}`, componentOverride: components?.Message, dangerouslySetInnerHTML: { __html: additionalMessage } }), _jsx(MessageAdditional, { variant: type, fontSize: fontSize, "data-testid": `support-chat-message-additional-${type}`, componentOverride: components?.MessageAdditional, dangerouslySetInnerHTML: { __html: children } })] })), !additionalMessage && (_jsx(Message, { variant: type, fontSize: fontSize, "data-hj-suppress": "", "data-testid": `support-chat-message-${type}`, componentOverride: components?.Message, dangerouslySetInnerHTML: { __html: children } }))] }));
};
export default MessageItem;
